<ng-template #dropdownTriggerContent>
    <ng-content></ng-content>
</ng-template>

<ng-container *ngTemplateOutlet="dropdownTriggerContent"></ng-container>

<ng-template #dropdownOptionsList>
    <div class="drop-down drop-down__with-triangle {{'-theme-' + theme}} {{'-size-' + size || 'default'}} {{'-position-' + position}} {{'-width-' + width || 'regular'}} {{'-projection-'+projection}}{{preContent ? ' -with-pre-content': ''}}"
        directive-drop-down [openEvent]="openEvent" [open]="open" [trigger]="dropdownTriggerContent"
        [projection]="projection" [closeGlobalOnScroll]="closeGlobalOnScroll" (onToggle)="handleToggle($event)">
        <div class="drop-down__outer">
            <div class="drop-down__inner" directive-scroll>

                <div *ngIf="preContent" class="drop-down__pre-content" [@openClosed]="isOpen ? 'open' : 'closed'">
                    <ng-container *ngTemplateOutlet="preContent"></ng-container>
                </div>

                <ul class="drop-down__list">
                    <li class="drop-down__li" *ngFor="let option of options;trackBy: trackBy"
                        [ngClass]="{'is-selected': selected && option.Id === selected.Id}">
                        <span class="drop-down__label" (click)="optionSelected(option)">
                            <ng-container *ngTemplateOutlet="optionTemplate || null; context: {item: option}">
                            </ng-container>
                            <ng-container *ngIf="!optionTemplate">{{option.Name}}</ng-container>
                        </span>
                    </li>
                </ul>

                <div *ngIf="postContent" class="drop-down__post-content" [@openClosed]="isOpen ? 'open' : 'closed'">
                    <ng-container *ngTemplateOutlet="postContent"></ng-container>
                </div>

            </div>
        </div>
    </div>
</ng-template>

<ng-container *ngTemplateOutlet="projection === 'local' ? dropdownOptionsList : null"></ng-container>
